import { useState, useRef, useEffect } from "react";
import { IconArrowLeft, IconSend } from "@tabler/icons-react";
import styles from "./MobileConversationModal.module.css";
import { getNameInitials } from "../../../../utils/functions";
import ConversationBubbles from "./ConversationBubbles";

const COLOR_CLASSES = ["color0", "color1", "color2", "color3", "color4"];

export default function MobileConversationModal({
  open,
  thread,
  replyText,
  onReplyChange,
  onSend,
  onClose,
  readOnly,
}) {
  const [dragY, setDragY] = useState(0);
  const [dragging, setDragging] = useState(false);
  const startYRef = useRef(0);
  const textareaRef = useRef(null);

  useEffect(() => {
    if (replyText === "" && textareaRef.current) {
      textareaRef.current.style.height = "auto";
    }
  }, [replyText]);

  function handleTouchStart(e) {
    startYRef.current = e.touches[0].clientY;
    setDragging(true);
  }

  function handleTouchMove(e) {
    if (!dragging) return;
    const dy = e.touches[0].clientY - startYRef.current;
    if (dy > 0) setDragY(dy);
  }

  function handleTouchEnd(e) {
    setDragging(false);
    const dy = e.changedTouches[0].clientY - startYRef.current;
    setDragY(0);
    if (dy > 120) onClose();
  }

  function handleInput(e) {
    onReplyChange(e.target.value);
    const el = e.target;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  }

  const colorClass = thread
    ? styles[COLOR_CLASSES[thread.color] || "color0"]
    : "";

  return (
    <div
      className={`${styles.backdrop} ${open ? styles.open : ""}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className={`${styles.modal} ${dragging ? styles.modalDragging : ""}`}
        style={dragY ? { transform: `translateY(${dragY}px)` } : undefined}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div className={styles.handle} />
        <div className={styles.header}>
          <button className={styles.backBtn} onClick={onClose}>
            <IconArrowLeft size={18} />
          </button>
          <div className={styles.info}>
            <div className={styles.subject}>
              {thread ? thread.subject : "—"}
            </div>
            <div className={styles.sub}>
              {thread ? `${thread.sender} · ${thread.type}` : "—"}
            </div>
          </div>
          <div className={`${styles.avatar} ${colorClass}`}>
            {thread ? getNameInitials(thread.sender) : "?"}
          </div>
        </div>

        {thread && <ConversationBubbles messages={thread.messages} />}

        {readOnly ? (
          <div className={styles.reply}>
            <p style={{ margin: 0, fontSize: 13, color: "var(--muted, #6b7280)" }}>
              Replies from the support team appear here. To add to this request, raise it from the Support page.
            </p>
          </div>
        ) : (
          <div className={styles.reply}>
            <textarea
              ref={textareaRef}
              className={styles.input}
              placeholder="Write a reply…"
              rows={1}
              value={replyText}
              onChange={handleInput}
            />
            <button className={styles.send} onClick={onSend}>
              <IconSend size={18} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
